import hoistNonReactStatic from 'hoist-non-react-statics';
import { getDataDependency, getDisplayName } from 'gandi.react-helpers';
import TranslatorPropsContext from './TranslatorPropsContext';
import createTranslatorProps from './createTranslatorProps';
import { jsx as _jsx } from "react/jsx-runtime";
const provideTranslate = (translator, namespace) => WrappedComponent => {
  if (namespace && global.__DEV__) {
    console.warn('DEPRECATION WARNING:\n' + 'provideTranslator(translator, namespace) is deprecated.\n' + 'Use provideTranslator(translator) instead.\n' + 'The translation namespace is now defined in your application configuration.');
  }
  const translatorProps = createTranslatorProps(translator);
  function ProviderTranslate(props) {
    return /*#__PURE__*/_jsx(TranslatorPropsContext.Provider, {
      value: translatorProps,
      children: /*#__PURE__*/_jsx(WrappedComponent, {
        ...props
      })
    });
  }
  ProviderTranslate.WrappedComponent = WrappedComponent;
  ProviderTranslate.displayName = `ProviderTranslate(${getDisplayName(WrappedComponent)})`;
  const HoistedComponent = hoistNonReactStatic(ProviderTranslate, WrappedComponent);
  const wrapHandler = handlerName => {
    const wrappedHandler = getDataDependency(WrappedComponent, handlerName);
    HoistedComponent[handlerName] = (props, ...extra) => {
      props.res.locals.translator = translator;
      if (!wrappedHandler) {
        return Promise.resolve();
      }
      return wrappedHandler(props, ...extra);
    };
    return HoistedComponent;
  };
  wrapHandler('preFetch');
  wrapHandler('handleRedirect');
  wrapHandler('handleForm');
  return ProviderTranslate;
};
export default provideTranslate;